module.exports = __webpack_public_path__ + "img/gox.f840ad6e.png";